import { roundUp } from "./UniformBufferManager";
export class UniformBufferAlone {
    constructor(size, manager, user) {
        this._destroyed = false;
        this.uploadNum = 0;
        this.data = new ArrayBuffer(size);
        this.buffer = manager.getBufferAlone(size);
        this._manager = manager;
        this._size = size;
        this._alignedSize = roundUp(size, manager.byteAlign);
        this.user = user;
        manager.aloneBuffers.push(this);
    }
    upload() {
        this._manager.writeBuffer(this.buffer, this.data, 0, this._size);
    }
    destroy() {
        if (!this._destroyed) {
            this.data = null;
            if (this.buffer.destroy)
                this.buffer.destroy();
            this._manager.statisGPUMemory(-this._size);
            this._manager.aloneBuffers.splice(this._manager.aloneBuffers.indexOf(this), 1);
            this._destroyed = true;
            return true;
        }
        console.warn('UniformBufferAlone: object alreay destroyed!');
        return false;
    }
}
